import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function OldSolutionsSection() {
  return <section className="bg-white py-20 px-4" data-id="element-131">
      <div className="max-w-2xl mx-auto" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-133">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-8 text-center" data-id="element-134">
            Por qué lo que ya intentaste no funciona
          </h2>

          <div className="bg-gray-50 p-8 rounded-xl mb-8" data-id="element-135">
            <p className="text-lg md:text-xl text-[#2D2A26] mb-6" data-id="element-136">
              Porque la mayoría de consejos están hechos para gente con:
            </p>
            <ul className="grid grid-cols-2 gap-4 mb-2" data-id="element-137">
              {['Energía alta', 'Tiempo', 'Excel', 'Apps', 'Disciplina perfecta'].map((item, i) => <li key={i} className="flex items-center gap-2 text-gray-600" data-id="element-138">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-139" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-[#1B2A4A] text-[#F5F0E8] p-8 rounded-xl shadow-lg relative overflow-hidden" data-id="element-140">
            <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-[#C94040] rounded-full opacity-20 blur-xl" data-id="element-141"></div>

            <div className="flex gap-4 mb-4" data-id="element-142">
              <AlertCircle className="w-8 h-8 text-[#C94040] flex-shrink-0" data-id="element-143" />
              <p className="text-xl md:text-2xl font-bold" data-id="element-144">
                Y tú necesitas algo que funcione cuando estás:
              </p>
            </div>

            <ul className="space-y-3 ml-12 mb-8" data-id="element-145">
              {['Cansada', 'Con la mente llena', 'Con letra pequeña que te molesta', 'Con estrés'].map((item, i) => <li key={i} className="text-lg opacity-90 list-disc" data-id="element-146">
                  {item}
                </li>)}
            </ul>

            <p className="text-xl md:text-2xl font-serif font-bold text-center border-t border-white/20 pt-6" data-id="element-147">
              Este plan fue diseñado para vida real.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}